"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEvent = void 0;
var isEvent = function (eventOrValue) {
    return (typeof eventOrValue === "object" &&
        eventOrValue !== null &&
        "target" in eventOrValue);
};
exports.isEvent = isEvent;
